import React, { useEffect } from 'react'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import WhatsappSidebar from './WhatsappSidebar';
import WhatsappChatSection from './WhatsappChatSection';
import { getUserList, setSelectedContact, getUserMessages } from '../../state/whatsapp/whatsappSlice';
import { selectWhatsappState } from '../../state/whatsapp/whatsappSelector';

const WhatsappBusiness = () => {
    const dispatch = useDispatch();
    const { selectedContact } = useSelector(selectWhatsappState);

    useEffect(() => {
        dispatch(getUserList());
    }, []);

    const handleSelectContact = (contact) => {
        dispatch(setSelectedContact(contact));
        const phone = contact.phone.replace('whatsapp:', '').replace('+', '');
        dispatch(getUserMessages({ phone, page: 1, perPage: 1000 }));
    };

    return (
        <Paper elevation={0}>
            {/* <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Box>
                    <Typography variant="h5" gutterBottom>
                        Whatsapp Business
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        Manage your whatsapp business account ({process.env.REACT_APP_WHATSAPP_BUSINESS_NUMBER}).
                    </Typography>
                </Box>
                <Button variant="contained" startIcon={<AddIcon />}>
                    Start new Conversation
                </Button>
            </Stack> */}
            <Paper variant="outlined" sx={{ overflow: 'hidden', borderRadius: '8px' }}>
                <Stack direction="row">
                    <WhatsappSidebar selectedContact={selectedContact} onSelectContact={handleSelectContact} />
                    <WhatsappChatSection selectedContact={selectedContact} />
                </Stack>
            </Paper>
        </Paper>
    );
}
export default WhatsappBusiness
